import { getBackgroundCSS, getBorderCSS, getColorsCSS, getIconCSS, getShadowCSS, getSpaceCSS, getTypoCSS } from '../../../../Components/utils/getCSS';

const Style = ({ attributes, clientId }) => {
	const { boxes, columnGap, rowGap, boxHeight, textAlign, boxPadding, iconMargin, titleTypo, titleMargin, descTypo, btnTypo, btnPadding } = attributes;

	const mainSl = `#bBlocksFlipBoxes-${clientId}`;
	const gFlipBoxSl = `${mainSl} .bBlocksFlipBox`;

	return <>
		<style dangerouslySetInnerHTML={{
			__html: `
			${getTypoCSS('', titleTypo)?.googleFontLink}
			${getTypoCSS('', descTypo)?.googleFontLink}
			${getTypoCSS('', btnTypo)?.googleFontLink}
			${getTypoCSS(`${gFlipBoxSl} .flipTitle`, titleTypo)?.styles}
			${getTypoCSS(`${gFlipBoxSl} .flipDescription`, descTypo)?.styles}
			${getTypoCSS(`${gFlipBoxSl} .flipBtn`, btnTypo)?.styles}

			${mainSl} .bBlocksFlipBoxes{ grid-gap: ${rowGap} ${columnGap}; }
			${gFlipBoxSl}{
				height: ${boxHeight};
			}
			${gFlipBoxSl} .box{
				text-align: ${textAlign};
				padding: ${getSpaceCSS(boxPadding)};
			}
			${gFlipBoxSl} i.flipIcon{
				margin: ${getSpaceCSS(iconMargin)};
			}
			${gFlipBoxSl} i.flipTitle{
				margin: ${getSpaceCSS(titleMargin)};
			}
			${gFlipBoxSl} .flipBtn{
				padding: ${getSpaceCSS(btnPadding)};
			}
			`.replace(/\s+/g, ' ')
		}} />

		{boxes.map((item, index) => {
			const { frontBG, backBG, border, shadow, frontIcon = {}, frontIconWidth = '70px', backIcon = {}, backIconWidth = '70px', frontTitleColor, backTitleColor, descColor, btnBorder, btnColors, btnHovColors } = item;

			const flipBoxSl = `${mainSl} #bBlocksFlipBox-${index}`;

			return <style key={index} dangerouslySetInnerHTML={{
				__html: `
				${flipBoxSl} .box{
					${getBorderCSS(border)}
					box-shadow: ${getShadowCSS(shadow)};
				}
				${flipBoxSl} .box.front{
					${getBackgroundCSS(frontBG)}
				}
				${flipBoxSl} .box.back{
					${getBackgroundCSS(backBG)}
				}
				${flipBoxSl} img.flipIcon.frontIcon{
					width: ${frontIconWidth};
				}
				${flipBoxSl} i.flipIcon.frontIcon{
					${getIconCSS(frontIcon)}
				}
				${flipBoxSl} img.flipIcon.backIcon{
					width: ${backIconWidth};
				}
				${flipBoxSl} i.flipIcon.backIcon{
					${getIconCSS(backIcon)}
				}
				${flipBoxSl} .flipTitle.flipFrontTitle{
					color: ${frontTitleColor};
				}
				${flipBoxSl} .flipTitle.flipBackTitle{
					color: ${backTitleColor};
				}
				${flipBoxSl} .flipDescription{
					color: ${descColor};
				}
				${flipBoxSl} .flipBtn{
					${getColorsCSS(btnColors)}
					${getBorderCSS(btnBorder)}
				}
				${flipBoxSl} .flipBtn:hover{
					${getColorsCSS(btnHovColors)}
				}
				`.replace(/\s+/g, ' ')
			}} />;
		})}
	</>;
}
export default Style;